export function linkToAnonymousUnsubscribePage() {
  return `/unsubscribe/:encryptedContactKey`;
}
